"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSizeString = exports.formatTimeShort = exports.formatTime = exports.formatNumberQuantity = exports.formatDatetimeForRequest = exports.formatDateWithHour = exports.formatDateShortTwoDigits = exports.formatDateShort = exports.formatDateLongYear = exports.formatDateForRequest = void 0;

var _dateFns = require("date-fns");

var _es = _interopRequireDefault(require("date-fns/locale/es"));

var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));

var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var locales = {
  es: _es["default"],
  en: _enUS["default"],
  pt: _ptBR["default"]
};
var dateFormats = {
  es: 'd/M/yy',
  en: 'M/d/yy',
  pt: 'd/M/yy'
};
var dateFormatsTwoDigits = {
  es: 'dd/MM/yyyy',
  en: 'MM/dd/yyyy',
  pt: 'dd/MM/yyyy'
};
var dateFormatsWithHour = {
  es: "dd/MM/yyyy 'a las' HH:mm",
  en: "MM/dd/yyyy 'at' HH:mm",
  pt: "dd/MM/yyyy 'às' HH:mm"
};

var formatTime = function formatTime(time) {
  if (!isNaN(time)) {
    var showWith0 = function showWith0(value) {
      return value < 10 ? '0' + value : value;
    };

    var hours = Math.floor(time / 3600);
    var minutes = Math.floor(time / 60 % 60);
    var seconds = showWith0(Math.floor(time % 60));
    return (hours > 0 ? hours + ':' + showWith0(minutes) : minutes) + ':' + seconds;
  } else {
    return '';
  }
};

exports.formatTime = formatTime;

var formatNumberQuantity = function formatNumberQuantity(n) {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

exports.formatNumberQuantity = formatNumberQuantity;

var formatDateShort = function formatDateShort(date) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormats[lang], {
    locale: locales[lang]
  });
};

exports.formatDateShort = formatDateShort;

var formatDateShortTwoDigits = function formatDateShortTwoDigits(date) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormatsTwoDigits[lang], {
    locale: locales[lang]
  });
};

exports.formatDateShortTwoDigits = formatDateShortTwoDigits;

var formatDateLongYear = function formatDateLongYear(date) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'PPP', {
    locale: locales[lang]
  });
};

exports.formatDateLongYear = formatDateLongYear;

var formatDateForRequest = function formatDateForRequest(date) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), 'yyyy-MM-dd');
};

exports.formatDateForRequest = formatDateForRequest;

var formatDatetimeForRequest = function formatDatetimeForRequest(date) {
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), "yyyy-MM-dd'T'HH:mm:ss");
};

exports.formatDatetimeForRequest = formatDatetimeForRequest;

var formatDateWithHour = function formatDateWithHour(date) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
  return (0, _helpers.isValidDate)(date) && (0, _dateFns.format)(new Date(date), dateFormatsWithHour[lang]);
};

exports.formatDateWithHour = formatDateWithHour;

var formatTimeShort = function formatTimeShort(date) {
  return (0, _helpers.isValidDate)(date) && new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

exports.formatTimeShort = formatTimeShort;

var getSizeString = function getSizeString(sizeInKB) {
  if (sizeInKB > 1000000) return "".concat((sizeInKB / 1000000).toFixed(2), " GB");
  if (1000000 > sizeInKB && sizeInKB > 1000) return "".concat((sizeInKB / 1000).toFixed(2), " MB");
  if (sizeInKB < 1000) return "".concat(sizeInKB.toFixed(2), " KB");
};

exports.getSizeString = getSizeString;